import React from 'react';

import classnames from 'classnames';

import classes from '@nerdwallet/base-styles/classes';
import { Box, Text, Type } from '@nerdwallet/currency';
import { Num as num } from '@nerdwallet/nw-client-lib';
import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

import ImageSizes from '../../../config/images/imageSizes';

import styles from './index.module.less';

interface MonthlyResultsProps {
  total: number;
  loanTerm: string;
  className?: string;
  headerText?: string;
}

const MonthlyResults: React.FC<MonthlyResultsProps> = ({
  total,
  loanTerm,
  className,
  headerText,
}) => (
  <div className={classnames(className, classes('position-relative'))}>
    <Box className={classes('text-align-center')}>
      <Text size="default">{headerText}</Text>
      <Type size="4">{num.formatCurrency(total)}</Type>
      <Type color="neutral-dark" size="2" fontFamily="gotham">
        {loanTerm}-year fixed loan term
      </Type>
    </Box>
    <img
      className={classnames(styles.houseIcon, classes('position-absolute'))}
      {...ImageSizes.largeIcon.measures}
      alt=""
      src={iconUri('House_pricetag')}
    />
  </div>
);

export default MonthlyResults;
